import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerSearchInfo } from './types/RsCustomerSearchInfo';

export type ICustomerSearchDataProvider = IDataProviderV2<RsCustomerSearchInfo>;

@A9Service('customerSearchDataProvider')
export class CustomerSearchDataProvider extends AbstractDataProviderV2<RsCustomerSearchInfo> implements ICustomerSearchDataProvider {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/search');
    }

    get(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    update(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    remove(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
